module.exports = __webpack_public_path__ + "img/dankoff_logo.c901c289.png";